import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_PUBLISHABLE_KEY. Copy frontend/.env.example to frontend/.env.'
  );
}

export const supabase = createClient(url, key);

// Escape characters that are special inside a PostgREST `or()` filter value.
export const escapeFilterValue = (value) => value.replace(/[,()*%\\"]/g, ' ').trim();
